import React, { useEffect, useState } from 'react'
import { getLeagues } from '../../../api/api_football'
import { addCacheByKey, getCacheByKey } from '../../../cache/cache'
import LeagueSelectorListItem from './Templates/LeagueSelectorListItem'

function LeagueSelector({ league, setLeague }) {

    const [leagues, setLeagues] = useState([])
    const [filteredLeagues, setFilteredLeagues] = useState([])
    const [show, setShow] = useState(false);
    const [searchTerm, setSearchTerm] = useState("")

    useEffect(() => {
        async function getAllLeagues() {

            const leaguesLS = getCacheByKey("leaguesAPI")
            if (leaguesLS?.length > 0) {
                setLeagues(leaguesLS)
                console.log("GETTING CACHED LEAGUES");
                return
            }
            if (!leaguesLS?.length) {
                console.log("GETTING API DATA");
                const data = await getLeagues()
                if (data?.length > 0) {
                    setLeagues(data)
                    addCacheByKey("leaguesAPI", data)
                }
            }
        }
        getAllLeagues()
    }, [])

    function filterLeagues(searchTerm) {
        const filtered = leagues?.filter(league => {
            return league?.name.toLowerCase().trim().includes(searchTerm.toLowerCase()) || league?.country.toLowerCase().trim().includes(searchTerm.toLowerCase())
        })
        return filtered
    }

    useEffect(() => {
        if (searchTerm !== "") {

            const filteredResult = filterLeagues(searchTerm)
            setFilteredLeagues(filteredResult)
        } else {
            setFilteredLeagues(leagues)
        }

    }, [searchTerm])

    return (
        <div>
            <div className="card card-header" onClick={() => setShow(show => !show)}>
                <div> Velg liga <span className="float-right">
                    <i className={`fas fa-chevron-${show ? "up" : "down"}`}></i></span></div>
            </div>
            {show && (
                <React.Fragment>
                    <div className="form-group">
                        <label>Søk liga</label><br />
                        <input className="form-control" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                    </div>
                    <ul className="list-group">
                        {filteredLeagues?.map((item, index) => {
                            return <LeagueSelectorListItem key={index} league={item} setSelectedLeague={setLeague} selectedLeague={league} />
                        })}
                    </ul>
                </React.Fragment>
            )}
        </div>
    )
}
export default LeagueSelector